import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  actionButton: {
    position: 'fixed',
    bottom: '77px',
    right: '76px',
    backgroundColor: palette.shades[100],
    boxShadow: palette.shadows.hard,
    zIndex: '10'
  },
  pageLink: {
    position: 'relative',
    padding: '10px 40px',
    fontSize: '15px',
    lineHeight: '20px',
    color: palette.shades[700],
    fontFamily: palette.fontFamilies.source,
    transition: "all ".concat(palette.transitions.short),
    '&:hover': {
      backgroundColor: palette.shades[300],
      color: palette.shades[700]
    }
  },
  pageLinkDisabled: {
    opacity: '0.5',
    '&:hover': {
      backgroundColor: 'transparent',
      color: palette.shades[700],
      cursor: 'not-allowed'
    }
  },
  pageLinkActive: {
    backgroundColor: palette.shades[300],
    '&:hover': {
      backgroundColor: palette.shades[400]
    }
  },
  tabletIndicator: {
    position: 'absolute',
    top: '8px',
    left: '10px',
    '& path': {
      fill: palette.shades[700]
    }
  },
  toggler: {
    padding: '20px 10px',
    marginTop: '8px',
    borderTop: "1px solid ".concat(palette.shades[300]),
    '& .MuiFormControlLabel-label': {
      fontSize: '15px',
      lineHeight: '20px',
      color: palette.shades[700]
    },
    '& + &': {
      marginTop: '0'
    }
  }
});
export default useStyles;